import React from "react";
import withToken from "../../../auth/HOC/withToken";
import withUserCategory from "../arc/UserCategory";
import withARCLoader from "../../../auth/HOC/withARCLoader";
import useToggle from "../../../hooks/useToggle";
import EditCategoryDialog from "./EditCategoryDialog";
import { List, ListItemIcon } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import navigate from "../../../../singletons/navigate";
import commons from "../commons";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import useFormState from "../../../hooks/useFormState";
import Field from "../../../../layout/inputs/Field";
import { CheckCircle } from "@mui/icons-material";

const Categories = ({
  model,
  fetch,
  onItemClick,
  size = 200,
  showCreate = true,
  showFilter = false,
  containerData,
}) => {
  const [visible, setVisible] = useToggle(false);
  const [form, setForm] = useFormState({ filter: "" });
  const onSuccess = () => {
    fetch();
    setVisible(false);
  };

  const items = model.slice(0, size).reduce((state, item) => {
    if (form.filter) {
      const found =
        item.title.toLowerCase().indexOf(form.filter.toLowerCase()) > -1 ||
        item.description.toLowerCase().indexOf(form.filter.toLowerCase()) > -1;
      return found ? state.concat(item) : state;
    }
    return state.concat(item);
  }, []);

  const isAlreadyPicked = (node, id) => {
    if (!node || !node.contents || node.contents.length < 1) return false;
    return node.contents.some((p) => {
      return p.food_id === id || isAlreadyPicked(p, id);
    });
  };

  return (
    <div>
      <EditCategoryDialog
        open={visible}
        onClose={() => setVisible(false)}
        onSuccess={onSuccess}
      />
      {showFilter && (
        <Field
          model={form}
          prop={"filter"}
          placeholder={"Filter les catégories"}
          onChange={setForm}
        />
      )}

      <List className="menu-go-list">
        {items.map((item) => (
          <ListItem
            key={item.id}
            button
            className="menu-go-list-item"
            onClick={() =>
              onItemClick
                ? onItemClick(item)
                : navigate(commons.basePath + "/" + item.id)
            }
          >
            {/*<ListItemAvatar>*/}
            {/*    <Avatar style={{backgroundColor: colorHash.hex(item.title)}}>*/}
            {/*        {item.title?.[0] || ''}*/}
            {/*    </Avatar>*/}
            {/*</ListItemAvatar>*/}
            <ListItemText
              primary={<strong>{item.title}</strong>}
              secondary={item.description?.substr(0, 50)}
            />

            {isAlreadyPicked(containerData, item.id) && (
              <ListItemIcon children={<CheckCircle />} />
            )}
          </ListItem>
        ))}
      </List>
      {showCreate && (
        <Button
          onClick={() => setVisible(true)}
          style={{ display: "block", width: "100%" }}
        >
          Créer une nouvelle {commons.singular}
        </Button>
      )}
    </div>
  );
};

Categories.propTypes = {};
Categories.defaultProps = {};

export default withToken(withUserCategory(withARCLoader(Categories)));
